import { Dialog, Notify, Quasar } from "quasar";
import iconSet from "quasar/icon-set/fontawesome-v6";

// Styles
import "quasar/src/css/index.sass";

// Language
import nl from "quasar/lang/nl";

export default {
  install: (app) => {
    app.use(Quasar, {
      lang: nl,
      iconSet,
      plugins: {
        Notify,
        Dialog,
      },
      config: {
        notify: {
          position: "bottom",
          timeout: 3000,
        },
      },
    });

    Notify.registerType("positive", {
      icon: "fa-solid fa-circle-check",
      classes: "c-notify c-notify--positive",
      actions: [{ icon: "fas fa-xmark", class: "c-notify__close" }],
    });

    Notify.registerType("warning", {
      timeout: 10000,
      icon: "fa-solid fa-triangle-exclamation",
      classes: "c-notify c-notify--warning",
      actions: [{ icon: "fas fa-xmark", class: "c-notify__close" }],
    });

    Notify.registerType("negative", {
      timeout: 10000,
      icon: "fa-solid fa-circle-xmark",
      classes: "c-notify c-notify--negative",
      actions: [{ icon: "fas fa-xmark", class: "c-notify__close" }],
    });

    Notify.registerType("info", {
      icon: "fa-solid fa-circle-info",
      classes: "c-notify c-notify--info",
      actions: [{ icon: "fas fa-xmark", class: "c-notify__close" }],
    });
  },
};
